$(function() {

var origHtmlMargin = parseFloat($('html').css('margin-top')); // Get the original margin-top of the HTML element so we can take that into account
var bannerHeight = $('#smartWebBanner').height();
	
function setCookie(name,value,exdays){
			var exdate = new Date();
			exdate.setDate(exdate.getDate()+exdays);
			var cookieValue=encodeURI(value)+((exdays===null)?'':'; expires='+exdate.toUTCString());
			document.cookie=name+'='+cookieValue+'; path=/;';
}

function getCookie(name){
	var i,x,y,ARRcookies = document.cookie.split(";");
	for(i=0;i<ARRcookies.length;i++){
		x = ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
		y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
		x = x.replace(/^\s+|\s+$/g,"");
		if(x===name){
			return decodeURI(y);
		}
	}
}
			
function closeBanner(){
	$('#smartWebBanner').fadeOut(400);
	$('footer .navbar').animate({ paddingBottom: 0  }, function(){
		setCookie('swb-closed','true', 90);
		$('html').removeClass('swb-shown');
		$('html').addClass('swb-closed');
	});
}

function showBanner(){
	$('#smartWebBanner').fadeIn(300);
	$('footer .navbar').animate({ paddingBottom: "4.85em"  }, 300, function(){
		$('html').addClass('swb-shown');
		$('html').removeClass('swb-closed');
	});
	
	$('#swb-close').on('click',function(){
		closeBanner();
		return false;
	});
	
	$('#swb-save,#swb-icon').on('click',function(){
		setCookie('swb-saved', 'true', 90);
		return true;
	});
}

function isAndroid() {
	var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("android") > -1;
}

if($('#smartWebBanner').length && isAndroid() && !getCookie('swb-closed') && !getCookie('swb-saved')) {
	showBanner();
}

});